import { TranslateService } from '@ngx-translate/core';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CustomerProvider } from '../providers/customer/customer';

@Injectable()
export abstract class DateTimePipe implements PipeTransform {
  constructor(
    public customerProvider: CustomerProvider,
    public translate: TranslateService
  ) {}

  dateFormat(date) {
  
    let dateAsDate =  new Date(date);

    let lang = this.customerProvider.getCurrentLanguage();
    let separator = '/';

    let day = ((dateAsDate.getDate())>=10)? (dateAsDate.getDate()) : '0' + (dateAsDate.getDate());
    let month = ((dateAsDate.getMonth()+1)>=10)? (dateAsDate.getMonth()+1) : '0' + (dateAsDate.getMonth()+1);

    return lang == 'en-US'
    ? `${month}${separator}${day}${separator}${dateAsDate.getFullYear()}`
    : `${day}${separator}${month}${separator}${dateAsDate.getFullYear()}`;
}


  timeFormat(date, text?: boolean) {

    let dateAsDate =  new Date(date);
    let hours = ((dateAsDate.getHours())>=10)? (dateAsDate.getHours()) : '0' + (dateAsDate.getHours());
    let minutes = ((dateAsDate.getMinutes())>=10)? (dateAsDate.getMinutes()) : '0' + (dateAsDate.getMinutes());

    if (typeof text != 'undefined' && text == false) {
      return `${hours}:${minutes}`;
    }
    return `${hours}:${minutes}h`;

  }
  abstract transform(value, args): string;
}

@Pipe({
  name: 'dateformat'
})
@Injectable()
export class DateFormatPipe extends DateTimePipe {
  transform(date) {
    let resul;
    if (date) resul = this.dateFormat(date);
    return resul ? resul : '';
  }
}

@Pipe({
  name: 'timeformat'
})
@Injectable()
export class TimeFormatPipe extends DateTimePipe {
  transform(date) {
    let resul;
    if (date) resul = this.timeFormat(date, false);
    return resul ? resul : '';
  }
}

@Pipe({
  name: 'datetimeformat'
})
@Injectable()
export class DateTimeFormatPipe extends DateTimePipe {
  transform(date) {
    let resul;
    if (date) resul = `${this.dateFormat(date)} ${this.timeFormat(date)}`;  
    return resul ? resul : '';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date-format-pipe.ts